import { collection, addDoc, getDocs, serverTimestamp, query, orderBy, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../../firebase/config';

export interface TravellingApprovalRequest {
    id?: string;
    requestId?: string;
    branchIds: string[];
    branchNames: string[];
    dateOfVisit: string;
    lastDateOfVisit: string;
    distance: number;
    status: 'pending' | 'forwarded' | 'approved' | 'rejected' | 'submitted';
    psoId: string;
    psoName: string;
    psoEmail: string;
    remarks?: string;
    approverRemarks?: string;
    createdAt?: any;
    purpose?: string;
    purposeOtherDetail?: string;
    nightStay?: boolean;
    amountClaim?: number;
    confirmAmount?: number;
    travelModality?: string;
}

export async function createTravellingApprovalRequest(bankId: string, request: Omit<TravellingApprovalRequest, 'id' | 'createdAt' | 'requestId'>) {
    const { doc, setDoc } = await import('firebase/firestore');
    const colRef = collection(db, 'banks', bankId, 'travelling_approvals');
    const docRef = doc(colRef);
    const id = docRef.id;

    let firstBranchCode = 'UNK';
    if (request.branchNames && request.branchNames.length > 0) {
        const parts = request.branchNames[0].split(' - ');
        if (parts.length > 0) {
            firstBranchCode = parts[0].trim();
        }
    }

    const requestId = `TADA-${firstBranchCode}-${id.slice(-4).toUpperCase()}`;

    await setDoc(docRef, {
        ...request,
        requestId,
        createdAt: serverTimestamp(),
    });
    return id;
}

export async function fetchTravellingApprovalRequests(bankId: string): Promise<TravellingApprovalRequest[]> {
    const colRef = collection(db, 'banks', bankId, 'travelling_approvals');
    const q = query(colRef, orderBy('createdAt', 'desc'));
    const snap = await getDocs(q);
    return snap.docs.map(doc => {
        const data = doc.data();
        return {
            id: doc.id,
            ...data,
            createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt
        } as TravellingApprovalRequest;
    });
}

export async function updateTravellingApprovalRequest(
    bankId: string,
    requestId: string,
    request: Partial<Omit<TravellingApprovalRequest, 'id' | 'createdAt'>>
) {
    const docRef = doc(db, 'banks', bankId, 'travelling_approvals', requestId);
    await updateDoc(docRef, request);
}

export async function updateTravellingApprovalStatus(
    bankId: string,
    requestId: string,
    status: 'forwarded' | 'approved' | 'rejected' | 'submitted',
    approverRemarks?: string,
    confirmAmount?: number
) {
    const docRef = doc(db, 'banks', bankId, 'travelling_approvals', requestId);
    const updates: any = { status };
    if (approverRemarks !== undefined) {
        updates.approverRemarks = approverRemarks;
    }
    if (confirmAmount !== undefined) {
        updates.confirmAmount = confirmAmount;
    }
    await updateDoc(docRef, updates);
}

export async function deleteTravellingApprovalRequest(bankId: string, requestId: string) {
    const docRef = doc(db, 'banks', bankId, 'travelling_approvals', requestId);
    await deleteDoc(docRef);
}
